import React from "react";
import { connect } from "react-redux";
import { logout } from "../store/actions/auth";
import { AccessDlgOpen } from "../store/actions/dlgs";
import withRouter from "../withRouter";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { DashboardOutlined, Groups2Outlined, CreateNewFolderOutlined, DatasetOutlined, SettingsOutlined, LogoutOutlined, MenuOutlined, CloseOutlined } from '@mui/icons-material';
import "../styles/Sidebar.scss";

class Comp extends React.Component {
  state = {

    theme: createTheme({
      palette: {
        primary: {
          main: "#F7931E",
        },
        secondary: {
          main: "#F9F9F9",
        },
      },
    }),
    navigate: "",
    open: true,
    mobileOpen: false
  };

  componentDidMount() {
    this.setState({ navigate: "" })
  };

  handleChange = e => {
  };

  handleSubmit = e => {
    e.preventDefault();
  };

  gotoPage = (path, locked) => {
    this.closeMobileSidebar();

    if (!locked) {
      this.props.AccessDlgOpen()
      return
    }

    this.props.navigate(path)
  }

  clickLogout = () => {
    this.props.logout()
    this.props.navigate("/login")
  }

  handleToggle = () => this.setState({open: !this.state.open});

  handleClose = () => this.setState({open: false});

  toggleMobileSidebar = () => this.setState({ mobileOpen: !this.state.mobileOpen });

  closeMobileSidebar = () => this.setState({ mobileOpen: false });

  render() {
    const { theme } = this.state;
    const { authUser, roleList, userList, permisionList, hideMenus, companies, groups } = this.props
    let userRequests = 0
    let permissions = {'p-3': true}

    userList.map(user => {
      if (user.pk === authUser.pk || !authUser.json_obj || !user.json_obj) return user
      if (user.json_obj.group_id === authUser.json_obj.group_id && user.is_waiting) userRequests++
      return user
    })

    const authRole = roleList?.filter(role => role.pk === authUser.user_role)[0]

    if (authRole)
      permisionList.filter(item => authRole.permissions["per-" + item.pk]).map(permission => permissions["p-" + permission.assign_menu] = true)

    if (!permissions['p-0'] && permissions['p-5']) {
      permissions['p-0'] = true
    }

    let companyName = '';
    const authUserGroup = groups?.find(g => g.pk === authUser?.json_obj?.group_id);
    if (authUserGroup) {
      companyName = companies?.find(c => c.tag_name === authUserGroup.tag_name)?.name || '';
    }

    const { mobileOpen } = this.state;

    return (
      <ThemeProvider theme={theme}>
        <button className="hamburger-btn" onClick={this.toggleMobileSidebar}>
          {mobileOpen ? <CloseOutlined /> : <MenuOutlined />}
        </button>
        <div className={`sidebar-overlay${mobileOpen ? ' open' : ''}`} onClick={this.closeMobileSidebar} />
        <div className={`sidebar-container${mobileOpen ? ' open' : ''}`}>
          <div className="sidebar-top">

            <div className="logo">
              <img src={require("../assets/imgs/vtg-logo.png")} width="120" alt="logo" />
            </div>

            <div className="menu-item" onClick={() => this.gotoPage("/dashboard", permissions["p-" + 0])}>
              <DashboardOutlined className="menu-item-icon" />
              <div className="menu-item-title">Dashboard</div>
            </div>

            {/* <div className="menu-item" onClick={() => this.gotoPage("/myteam", permissions["p-" + 1])}>
              <Groups2Outlined className="menu-item-icon" />
              <div className="menu-item-title">Team Management</div>
            </div> */}

            <div className="menu-item" onClick={() => this.gotoPage("/myteam", permissions["p-" + 1])}>
              <Groups2Outlined className="menu-item-icon" />
              <div className="menu-item-title">Team Management</div>
            </div>

            <div className="menu-item" onClick={() => this.gotoPage("/approve-teammates", permissions["p-" + 2])}>
              <CreateNewFolderOutlined className="menu-item-icon" />
              <div className="menu-item-title">New Requests</div>
            </div>

            <div className="menu-item" onClick={() => this.gotoPage("/", permissions["p-" + 3])}>
              <DatasetOutlined className="menu-item-icon" />
              <div className="menu-item-title">Your Assets</div>
            </div>
          </div>

          <div className="sidebar-bottom">
            <div className="menu-item" onClick={() => this.gotoPage("/settings", true)}>
              <SettingsOutlined className="menu-item-icon" />
              <div className="menu-item-title">Settings</div>
            </div>

            <div className="menu-item" onClick={(e) => { e.preventDefault(); this.clickLogout(); }}>
              <LogoutOutlined className="menu-item-icon" />
              <div className="menu-item-title">Log Out</div>
            </div>
          </div>

        </div>
      </ThemeProvider>
    );
  }
};

const mapStateToProps = state => {
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    token: state.auth.token,
    authUser: state.auth.user,

    userList: state.dashboard.users,
    roleList: state.dashboard.user_roles,
    permisionList: state.dashboard.permissions,
    hideMenus: state.dashboard.hidemenus,
    companies: state.dashboard.companies,
    groups: state.dashboard.groups
  };
};

const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(logout()),
    AccessDlgOpen: () => dispatch(AccessDlgOpen())
  };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Comp));
